<template>
  <div class="pagebox">
    <div @click="$router.go(-1)" style="background: #fff; padding: 16px 10px 10px">
      <van-icon name="arrow-left" size="22" />
      <span style="margin-left: 40%; font-weight: 600; font-size: 18px">饮食方案</span>
    </div>
    <div v-if="loading" class="loadbox">
      <van-loading size="50" vertical>加载中...</van-loading>
    </div>
    <div class="foodplan" v-else>
      <div class="left">
        <div v-for="item in typeList" :key="item.ikey">
          <div v-if="item.show" :class="leftChose == item.ikey ? 'left-box-chose' : 'left-box'" @click="goleft(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="left2"></div>
      <div class="right">
        <div class="card" id="zaocan" v-if="typeList[0].show">
          <div class="card-title">早餐</div>
          <div class="card-title-next"></div>
          <div
            class="card-inside-box"
            v-if="detail.zao_a || detail.zao_b || detail.zao_c || detail.zao_d || detail.zao_e || detail.zao_remark"
          >
            <div class="card-inside" v-if="detail.zao_a">
              <div class="dian">· 主食（粗细搭配）</div>
              <div>
                <span class="num">{{ detail.zao_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_b">
              <div class="dian">· 蛋白质类食物</div>
              <div>
                <span class="num">{{ detail.zao_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_c">
              <div class="dian">· 蔬菜</div>
              <div>
                <span class="num">{{ detail.zao_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_d">
              <div class="dian">（自选）多种营养素制剂</div>
              <div>
                <span class="num">{{ detail.zao_d }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_e">
              <div class="dian">（自选）鱼油胶囊（1克）</div>
              <div>
                <span class="num">{{ detail.zao_e }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.zao_remark">备注</div>
            <div class="tip" v-if="detail.zao_remark">
              {{ detail.zao_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(0) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="zaojiacan" v-if="typeList[1].show">
          <div class="card-title">早加餐</div>
          <div class="card-title-next"></div>
          <div class="card-inside-box" v-if="detail.zao_jia_a || detail.zao_jia_b || detail.zao_jia_c || detail.zao_jia_remark">
            <div class="card-inside" v-if="detail.zao_jia_a">
              <div class="dian">· 水果</div>
              <div>
                <span class="num">{{ detail.zao_jia_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_jia_b">
              <div class="dian">（或）低脂/脱脂牛奶</div>
              <div>
                <span class="num">{{ detail.zao_jia_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zao_jia_c">
              <div class="dian">（或）无糖酸奶</div>
              <div>
                <span class="num">{{ detail.zao_jia_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.zao_jia_remark">备注</div>
            <div class="tip" v-if="detail.zao_jia_remark">
              {{ detail.zao_jia_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(1) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="wucan" v-if="typeList[2].show">
          <div class="card-title">午餐</div>
          <div class="card-title-next"></div>
          <div
            class="card-inside-box"
            v-if="detail.zhong_a || detail.zhong_b || detail.zhong_c || detail.zhong_d || detail.zhong_e || detail.zhong_remark"
          >
            <div class="card-inside" v-if="detail.zhong_a">
              <div class="dian">· 主食（粗细搭配）</div>
              <div>
                <span class="num">{{ detail.zhong_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_b">
              <div class="dian">· 蛋白质类食物</div>
              <div>
                <span class="num">{{ detail.zhong_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_c">
              <div class="dian">· 蔬菜</div>
              <div>
                <span class="num">{{ detail.zhong_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_d">
              <div class="dian">（自选）多种营养素制剂</div>
              <div>
                <span class="num">{{ detail.zhong_d }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_e">
              <div class="dian">（自选）鱼油胶囊（1克）</div>
              <div>
                <span class="num">{{ detail.zhong_e }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.zhong_remark">备注</div>
            <div class="tip" v-if="detail.zhong_remark">
              {{ detail.zhong_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(2) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="wujiacan" v-if="typeList[3].show">
          <div class="card-title">午加餐</div>
          <div class="card-title-next"></div>
          <div class="card-inside-box" v-if="detail.zhong_jia_a || detail.zhong_jia_b || detail.zhong_jia_c || detail.zhong_jia_remark">
            <div class="card-inside" v-if="detail.zhong_jia_a">
              <div class="dian">· 水果</div>
              <div>
                <span class="num">{{ detail.zhong_jia_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_jia_b">
              <div class="dian">（或）低脂/脱脂牛奶</div>
              <div>
                <span class="num">{{ detail.zhong_jia_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.zhong_jia_c">
              <div class="dian">（或）无糖酸奶</div>
              <div>
                <span class="num">{{ detail.zhong_jia_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.zhong_jia_remark">备注</div>
            <div class="tip" v-if="detail.zhong_jia_remark">
              {{ detail.zhong_jia_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(3) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="wancan" v-if="typeList[4].show">
          <div class="card-title">晚餐</div>
          <div class="card-title-next"></div>
          <div
            class="card-inside-box"
            v-if="detail.wan_a || detail.wan_b || detail.wan_c || detail.wan_d || detail.wan_e || detail.wan_remark"
          >
            <div class="card-inside" v-if="detail.wan_a">
              <div class="dian">· 主食（粗细搭配）</div>
              <div>
                <span class="num">{{ detail.wan_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_b">
              <div class="dian">· 蛋白质类食物</div>
              <div>
                <span class="num">{{ detail.wan_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_c">
              <div class="dian">· 蔬菜</div>
              <div>
                <span class="num">{{ detail.wan_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_d">
              <div class="dian">（自选）多种营养素制剂</div>
              <div>
                <span class="num">{{ detail.wan_d }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_e">
              <div class="dian">（自选）鱼油胶囊（1克）</div>
              <div>
                <span class="num">{{ detail.wan_e }}</span>
                <span class="danwei">粒</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.wan_remark">备注</div>
            <div class="tip" v-if="detail.wan_remark">
              {{ detail.wan_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(4) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="wanjiacan" v-if="typeList[5].show">
          <div class="card-title">晚加餐</div>
          <div class="card-title-next"></div>
          <div class="card-inside-box" v-if="detail.wan_jia_a || detail.wan_jia_b || detail.wan_jia_c || detail.wan_jia_remark">
            <div class="card-inside" v-if="detail.wan_jia_a">
              <div class="dian">· 水果</div>
              <div>
                <span class="num">{{ detail.wan_jia_a }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_jia_b">
              <div class="dian">（或）低脂/脱脂牛奶</div>
              <div>
                <span class="num">{{ detail.wan_jia_b }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="card-inside" v-if="detail.wan_jia_c">
              <div class="dian">（或）无糖酸奶</div>
              <div>
                <span class="num">{{ detail.wan_jia_c }}</span>
                <span class="danwei">克</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.wan_jia_remark">备注</div>
            <div class="tip" v-if="detail.wan_jia_remark">
              {{ detail.wan_jia_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(5) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="quantianyinshui" v-if="typeList[6].show">
          <div class="card-title">全天饮水</div>
          <div class="card-title-next"></div>
          <div class="card-inside-box" v-if="detail.water || detail.diet_info">
            <div class="card-inside" v-if="detail.water">
              <div class="dian">每日饮水</div>
              <div>
                <span class="num">{{ detail.water }}</span>
                <span class="danwei">毫升</span>
              </div>
            </div>
            <div class="tip-title" v-if="detail.water_remark">备注</div>
            <div class="tip" v-if="detail.water_remark">
              {{ detail.water_remark }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(6) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
        <div class="card" id="jianyi" v-if="typeList[7].show">
          <div class="card-title">其他建议</div>
          <div class="card-title-next"></div>
          <div class="card-inside-box" v-if="detail.diet_info">
            <div class="tip-title">备注</div>
            <div class="tip">
              {{ detail.diet_info }}
            </div>
          </div>
          <div class="kongbai" v-else>
            <div v-if="flag">{{ show(7) }}</div>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { weightDetail } from "@/service/api";
import { set } from "vue";

export default {
  name: "foodPlan",
  components: {},
  props: {},
  data() {
    return {
      leftChose: "zaocan", // 左侧选中
      typeList: [
        { name: "早餐", ikey: "zaocan", show: true },
        { name: "早加餐", ikey: "zaojiacan", show: true },
        { name: "午餐", ikey: "wucan", show: true },
        { name: "午加餐", ikey: "wujiacan", show: true },
        { name: "晚餐", ikey: "wancan", show: true },
        { name: "晚加餐", ikey: "wanjiacan", show: true },
        { name: "全天饮水", ikey: "quantianyinshui", show: true },
        { name: "其他建议", ikey: "jianyi", show: true },
      ],
      detail: "",
      flag: false,
      loading:false,
    };
  },
  computed: {},
  created() {
    this.getDetail();
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener("scroll", this.scrolling);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
  watch: {},
  methods: {
    goleft(item) {
      this.flag = false;
      this.leftChose = item.ikey;
      document.querySelector(`#${this.leftChose}`).scrollIntoView(true);
    },
    getDetail() {
      this.loading=true
      weightDetail({ id: this.$route.query.id })
        .then((res) => {
          this.loading=false
          console.log("详情", res);
          this.detail = res.data;
          this.flag = true;
        })
        .catch((err) => {
          this.loading=false
          this.$toast(err);
        });
    },
    show(index) {
      this.$nextTick(() => {
        this.typeList[index].show = false;
        console.log("this.typeList", this.typeList);
      });
    },
    // 监听滚动条
    scrolling() {
      if (this.flag) {
        this.typeList.forEach((item) => {
          if (item.show) {
            let dom = document.getElementById(item.ikey);
            let rectObject = dom.getBoundingClientRect();
            if (rectObject.top < 8) {
              this.leftChose = item.ikey;
            }
          }
        });
      } else {
        this.flag = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pagebox {
  min-height: 100vh;
  background: #f5f5f5;
}
.loadbox{
  padding-top: 150px;
}
.foodplan {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  .left {
    position: fixed;
    box-sizing: border-box;
    width: 23%;
    min-height: 100vh;
    background: #fff;
    color: #9e9e9e;
    padding: 18px 15px;
    padding-right: 1px;
    font-size: 14px;
    .left-box,
    .left-box-chose {
      margin-bottom: 20px;
    }
    .left-box-chose {
      color: #4d8dff;
      padding-left: 6px;
      border-left: 5px solid #4d8dff;
    }
  }
  .left2 {
    width: 23%;
    background: #fff;
  }
  .right {
    box-sizing: border-box;
    width: 77%;
    padding: 15px;
    // padding-bottom: 900px;
    .card {
      margin-bottom: 15px;
      padding: 15px;
      background: #fff;
      border-radius: 8px;
      .kongbai {
        padding: 20px 0;
        color: #999;
        img {
          width: 80px;
          height: 80px;
          margin-bottom: 6px;
        }
        text-align: center;
      }
      .card-title {
        font-size: 16px;
        font-weight: bold;
      }
      .card-title-next {
        width: 35px;
        height: 10px;
        background: #b6c5f6;
        background: linear-gradient(to right, #b6c5f6, #fff);
      }
      .card-inside-box {
        flex-wrap: wrap;
        padding: 5px 10px;
        .card-inside {
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 10px 0;
          border-bottom: 1px solid #d9d9d9;
        }
        .card-inside:last-child {
          border-bottom: none;
        }
      }
      .dian {
        position: relative;
        padding-left: 10px;
        font-size: 12px;
      }
      // .dian::before {
      //   content: "";
      //   display: block;
      //   width: 6px;
      //   height: 6px;
      //   background-color: #90abff;
      //   position: absolute;
      //   left: 0;
      //   top: 6px;
      //   border-radius: 50%;
      // }
      .danwei {
        color: #afb0b0;
      }
      .tip-title {
        color: #afb0b0;
        margin: 10px 0;
      }
      .tip {
        font-size: 12px;
        text-align: justify;
        line-height: 20px;
      }
    }
  }
}
</style>
